import * as React from "react";
import {
  ELoginScreenState,
  EResetSubmitState,
  ELoginPopupState,
  urls,
} from "./loginConstants";
import LoginIdScreen from "./loginScreen/loginIdScreen";
import ee from "../utils/eventEmitter";
import {
  AGetSecurityImage,
  AVerifyAnswers,
  A2faQuestions,
  ASaveMulConsents,
  AGetConsents,
  AResetLoginId,
  AResetPassword,
  AMergeRequest,
  AMergeRemindLater,
  AMergeActivateAccount,
  AMergeEnableAccount,
  ARmRateSubmit,
  ACommAccOpenPre,
  ACommAccOpenPost,
  ARegisterDevice,
  ACheckTokenValidity,
  AImpersonateUser,
  AGetJwtTokenForNestRrader,
  AGetLoginResponse,
  ASaveTncConsent,
  ARetrieveQueryData,
} from "../service/login/loginApiService";
import PasswordScreen from "./loginScreen/passwordScreen";
import YobScreen from "./loginScreen/yobScreen";
import LoginService, {
  getPreLoginData,
  setPreLoginData,
  getUserID,
  setAccData,
  getAccData,
  parseQuery,
  logout,
  saveDataInLocalStorage,
  isLoggedIn,
  setUrlObj,
  cleverTapRegistration,
  createPlaceOrderUrl,
} from "../service/login/loginService";
import urlConfig from "../../config/domain";
import {
  IConsents,
  IConsentRes,
  IChangePassword,
  IMergeRequest,
  IVendorLogin,
} from "../types/components/login/loginTypes";
import ConsentScreen from "./loginScreen/consentScreen";
import ResetCredsScreen from "./loginScreen/resetCredsScreen";
import { IChPwFields } from "./forms/changePasswordForm";
import LoginStatusScreen from "./loginScreen/loginStatusScreen";
import LoginClevertapScreen from "./loginScreen/loginClevertapScreen";
import MergeIdScreen from "./loginScreen/mergeIdScreen";
import RmRatingScreen from "./loginScreen/rmRatingScreen";
import RmRatingSuccPopup from "./generic/rmRatingSuccPopup";
import OpenAccountScreen from "./loginScreen/openAccountScreen";
import LeadFormScreen from "./loginScreen/leadFormScreen";
import { ILeadFormFields } from "./forms/leadForm";
import { ClevertapService } from "./../service/clevertapService";
import DeviceContext from "../service/indentifyDevice";
import { RouteChildrenProps } from "react-router-dom";
import LoginLoaderScreen from "./loginScreen/loginLoaderScreen";
import indexer, { IAccDataCnsntLst } from "../types/genericTypes";
import TncConsentScreen from "./loginScreen/tncConsentScreen";
import loginURLConfig from "../../config/login/loginURLConfig";
import { setbStrg } from "../service/storageHelper";
import { ServiceClientValidation } from "../service/serviceRequest/srApiService";
import { IncomeDeclarationConsent } from "../clientarea/serviceRequest/incomeDeclaration/incomeDeclarationConsent";
import { ConsentPopupScreen } from "../clientarea/generic/consentPopup";
import { createBrowserHistory } from "history";

import { AccountReactivationConsent } from "../clientarea/serviceRequest/accReactivate/accReactCnst";
export interface ILoginCtrlProps {}

export interface ILoginCtrlState {
  screenState: ELoginScreenState;
  popupState?: ELoginPopupState; // if undefined then popup is closed otherwise open in corresponding state
  disableForm: boolean;
  imgObj?: Array<any>;
  errorMsg?: string;
  popupMessage?: string;
  consents?: Array<IConsentRes>;
  resetSubmitState?: EResetSubmitState;
  loginIdState?: string; // to be used in change password form
}

class LoginCtrl extends React.Component<
  ILoginCtrlProps & RouteChildrenProps,
  ILoginCtrlState
> {
  // login starts with LOGIN_ID screen
  state: ILoginCtrlState = {
    screenState: ELoginScreenState.LOADING,
    disableForm: false,
  };
  cnsList: { mandatory: boolean; list: Array<IConsents> } = {
    mandatory: false,
    list: [],
  };
  skipCnsts = false;
  clevertapService = new ClevertapService();
  history = createBrowserHistory({ forceRefresh: true });

  componentDidMount() {
    window.location.href = urlConfig.root;
    ee.on("changeLoginScreen", this.changeScreenState);
    //setting current page to login
    setbStrg("currentPage", "login");
    // If there is a query string in url, then read the values and store in Login Service
    if (window.location.search) {
      const { token } = parseQuery(window.location.search);

      // After reading, remove the query string from url
      this.removeQueryStringFromUrl();

      if (token) {
        ARetrieveQueryData(this.handleQueryString, token);
        return;
      }
    }

    this.afterHandleQueryString();
  }
  //tempOremove start
  //temporary fix - will be removed later
  componentWillUnmount() {
    setbStrg("currentPage", "");
  }
  //tempOremove end

  afterHandleQueryString = () => {
    // if user is logged in then redirect
    // if popupName is present then show popup
    // otherwise continue with normal login flow
    if (isLoggedIn() && !LoginService.popupName) {
      this.onClose();
      return;
    }

    this.openLogin();
  };

  handleQueryString = (res: any) => {
    if (res.data) {
      const queryObject = JSON.parse(res.data.value);

      if (queryObject.vsource) {
        // Vendor login
        sessionStorage.setItem("source", queryObject.vsource);
        sessionStorage.setItem("sourceToken", queryObject.sourcetoken);
        LoginService.vendorDetails = queryObject as IVendorLogin;
        LoginService.hideCross = true;

        setUrlObj(queryObject as IVendorLogin);
        this.skipCnsts = true;
      } else if (queryObject.source) {
        // smallcase / tradepoint login

        // set all the params so that we can redirect either logged in or not logged in
        if (queryObject.source === "smallcase") {
          LoginService.reUrl = urlConfig.smallcaseUrl;
          LoginService.params = queryObject.params;
        } else {
          LoginService.reUrl = urls.login;
        }

        // Check if user is already logged in
        if (isLoggedIn()) {
          ACheckTokenValidity(this.checkTokenValidityRes);

          return;
        }

        LoginService.hideCross = true;
        this.skipCnsts = true;
      } else if (queryObject.authToken) {
        // CIP login

        // Set jwt token so that it can be used in api
        LoginService.jwtToken = queryObject.authToken;
        AImpersonateUser(this.impersonateUserRes);

        return;
      } else if (queryObject.TokenId) {
        // Admin login
        logout();
        const userid = queryObject.UserId;
        const nesttraderRequest = {
          accID: queryObject.sAccountId,
          userID: userid,
          extoken: queryObject.TokenId,
          accTyp: queryObject.AccTyp,
        };
        AGetJwtTokenForNestRrader(
          this.getJwtTokenForNestRraderRes,
          nesttraderRequest
        );

        return;
      } else if (queryObject.auth_token) {
        // TX3 / EMT login
        logout();

        urlConfig.appidkey = queryObject.appidkey;
        queryObject.appidkey &&
          localStorage.setItem("appidkey", queryObject.appidkey);

        LoginService.jwtToken = queryObject.auth_token; // This will also set ptoken
        LoginService.reUrl = queryObject.reUrl || LoginService.reUrl;

        AGetLoginResponse(this.getLoginResponseRes);

        if (
          LoginService.pToken &&
          (LoginService.pToken.lgnSrc === "X" ||
            LoginService.pToken.lgnSrc === "iphone" ||
            LoginService.pToken.lgnSrc === "android-phone")
        ) {
          if (
            LoginService.pToken.lgnSrc === "iphone" ||
            LoginService.pToken.lgnSrc === "android-phone"
          ) {
            localStorage.setItem("ext_ptf", JSON.stringify(true));
          }
          LoginService.lgnSrc = LoginService.pToken.lgnSrc;
          localStorage.setItem("lgnSrc", LoginService.pToken.lgnSrc);
        }

        return;
      } else {
        // nromal login
        // if parameter present then set otherwise keep it as it is because it may have been already set
        LoginService.reUrl = queryObject.reUrl || LoginService.reUrl;
        if (LoginService.reUrl === "placeorder") {
          this.skipCnsts = true;
        }

        LoginService.invtypeobj = queryObject.invtypeobj
          ? JSON.parse(queryObject.invtypeobj)
          : LoginService.invtypeobj;
        LoginService.popupName =
          queryObject.popupName || LoginService.popupName;
        LoginService.params = queryObject.params
          ? queryObject.params
          : LoginService.params;

        if (LoginService.invtypeobj) {
          createPlaceOrderUrl(
            LoginService.invtypeobj.length
              ? (LoginService.invtypeobj as Array<indexer>)[0]
              : LoginService.invtypeobj
          );
        }
      }
    }

    this.afterHandleQueryString();
  };

  removeQueryStringFromUrl = () => {
    window.history.replaceState(
      {},
      document.title,
      window.location.href.split("?")[0]
    );
  };

  checkTokenValidityRes = (res: any, meta: any) => {
    if (meta.status === 200) {
      this.redirectToVendor();
    } else {
      this.changePopupState(ELoginPopupState.LOGIN_FAILED, {
        popupMessage: res,
      });
    }
  };

  redirectToVendor = () => {
    this.redirect(
      LoginService.reUrl +
        "?auth_token=" +
        LoginService.jwtToken +
        (LoginService.params ? "&" + LoginService.params : "")
    );
  };

  impersonateUserRes = (res: any) => {
    if (!res || res.errMsg) {
      this.changePopupState(ELoginPopupState.LOGIN_FAILED, {
        popupMessage: res ? res.errMsg.message : undefined,
      });
      return;
    }

    // Set the data
    setAccData(res);
    LoginService.jwtToken = res.jwt_token;
    setPreLoginData({ userID: res.accs.uid });

    // if urls.cipPassThroughBase is present then redirect there otherwise redirect to home page
    this.props.history.push(urls.cipPassThroughBase || urls.home);
    // this.history.push(urls.cipPassThroughBase || urls.home);
    window.location.reload();
  };

  getJwtTokenForNestRraderRes(res: any) {
    if (res) {
      window.localStorage.setItem("jwt_token", res);
      window.localStorage.setItem("nesttrader", "true");
      window.location.href = urls.report;
    } else {
      this.changePopupState(ELoginPopupState.LOGIN_FAILED, {
        popupMessage: res ? res.errMsg.message : undefined,
      });
    }
  }

  // CIP Login Response
  getLoginResponseRes = (res: any) => {
    if (res) {
      LoginService.setAccData(res);
      saveDataInLocalStorage();

      if (localStorage.getItem("appidkey"))
        urlConfig.appidkey = localStorage.getItem("appidkey")!;

      this.onClose();
    }
  };

  openLogin = () => {
    if (LoginService.popupName) {
      this.skipCnsts = true;
      switch (LoginService.popupName) {
        case "REQUESTED":
          // Show that user has already requested and it takes 24 hrs to merge
          this.changePopupState(ELoginPopupState.REQUESTED);
          break;

        case "NOT_REQUESTED":
          // Show the account merger screen
          this.changeScreenState(ELoginScreenState.MERGE);
          break;

        case "ONE_ACCOUNT":
          // show popup saying "Would you like to open one now?"
          // in case of equity, it takes to equity account opening pitch page
          // in case of commodity, saveleadinfo api is called
          this.changePopupState(ELoginPopupState.ONE_ACCOUNT);
          break;

        case "NOT_ENABLED":
          // if !isAct or !isOnline, then open send email popup
          // otherwise ask to login to the other account
          const othAccDts = getAccData("othAccDts");
          if (othAccDts.isAct && othAccDts.isOnline) {
            // show merge popup
            this.changePopupState(ELoginPopupState.NOT_ENABLED);
          } else {
            // show inactive account popup (send email popup)
            this.changePopupState(ELoginPopupState.INACTIVE_ACC);
          }
      }
    } else {
      this.changeScreenState(ELoginScreenState.LOGIN_ID);
    }
  };

  // optState is optional state that needs to be set along with screenState
  changeScreenState = (
    screenState: ELoginScreenState,
    optState?: { [key in keyof ILoginCtrlState]?: any }
  ) => {
    // if anything needs to be done specifically for a screen then only write the case
    switch (screenState) {
      case ELoginScreenState.LOGIN_ID:
        const userID = getUserID();
        setPreLoginData({ userID });

        if (userID) {
          this.getSecurityImage(userID);
        } else {
          this.setFocus("userID");
        }
        break;

      case ELoginScreenState.PASSWORD:
        this.setFocus("password");
        break;

      case ELoginScreenState.YOB:
        this.setFocus("yob-0");
        break;

      case ELoginScreenState.CLEVERTAP:
        // if none of below mentioned conditions is satisfied, then only code goes out of switch and shows the clevertap popup

        // if don't show again is present and it is equal to current logged in id, then directly go to onClose
        if (this.clevertapService.getClevertapItem("dontShowAgain")) {
          var prfId = this.clevertapService.getClevertapItem("dontShowAgain");
          if (prfId === getAccData("prfId")) {
            this.onClose();
            return;
          }
        }

        // if clevertap details are present in local storage, then check for other conditions; otheriwse show clevertap consent
        if (this.clevertapService.getClevertapItem("cleverTapDetails")) {
          var lastcleverTapDetails = this.clevertapService.getClevertapItem(
            "lastLoginDetails"
          )
            ? this.clevertapService
                .getClevertapItem("lastLoginDetails")
                .split(",")[0]
            : "";

          // If prf id matches the current account
          if (getAccData("prfId") === lastcleverTapDetails) {
            const cleverTapId = this.clevertapService.getCleverTapID();
            this.clevertapService.setClevertapItem({
              cleverTapDetails:
                getAccData("prfId") +
                "," +
                cleverTapId +
                ";expires=Tue, 19 Jan 2025 12:00:00 GMT",
            });
            this.onClose();
            return;
          }
        }
    }

    // setstate is common for all screens
    this.setState({
      screenState,
      disableForm: false,
      errorMsg: undefined,
      ...optState,
    });
  };

  changePopupState = (popupState?: ELoginPopupState, optState?: any) => {
    this.setState({ popupState, ...optState });
  };

  //Set Focus
  setFocus = (id: string) => {
    setTimeout(function () {
      (document as Document).getElementById(id)?.focus();
    }, 150);
  };

  // this function is called after clicking on edit userid button on password screen
  showUserIdScreen = () => {
    this.setState({
      screenState: ELoginScreenState.LOGIN_ID,
      disableForm: false,
      errorMsg: undefined,
    });
  };

  // this function is called to remove error msg
  removeError = () => {
    this.setState({ errorMsg: undefined, disableForm: false });
  };

  // Called when user clicks on preceed on userid screen
  // used to get security image list
  getSecurityImage = (userID: string) => {
    this.setState({ disableForm: true });
    setPreLoginData({ userID: userID.toUpperCase() });
    AGetSecurityImage(this.getSecurityImageRes, userID.toUpperCase());
  };

  // response of security image list
  getSecurityImageRes = (res: any) => {
    if (res.data && res.data.imgLst) {
      this.changeScreenState(ELoginScreenState.PASSWORD, {
        imgObj: res.data.imgLst,
      });
      localStorage.setItem(
        "AccList",
        JSON.stringify(res.data.imgLst.map((list: any) => list.typ))
      );
    } else {
      this.setState({ errorMsg: res.error.errMsg, disableForm: false });
    }
  };

  // called first when user clicks on proceed on password screen
  // used to validate the combination of userid and password
  faQuestions = (pwd: string, accTyp: string) => {
    this.setState({ disableForm: true });
    setPreLoginData({ accTyp, pwd });
    A2faQuestions(this.faQuestionsRes, getPreLoginData("userID"), accTyp, pwd);
  };

  // response of 2faquestions
  faQuestionsRes = (res: any) => {
    if (res.data) {
      this.changeScreenState(ELoginScreenState.YOB);
    } else {
      this.setState({ errorMsg: res.error.errMsg, disableForm: false });
    }
  };

  // used to verify yob
  verifyAnswers = (yob: string) => {
    this.setState({ disableForm: true });
    // pass vendor details if vendor is availables
    AVerifyAnswers(
      this.verifyAnswersRes,
      getPreLoginData("userID"),
      getPreLoginData("accTyp"),
      yob
    );
  };

  // response of verify yob
  verifyAnswersRes = (res: any, meta: Response) => {
    if (res) {
      if (res.data && res.data.sts !== "INVALID_ANSWERS") {
        // set all data in dataservice
        setAccData(res.data);
        cleverTapRegistration();

        if (meta.headers.get("appidkey")) {
          urlConfig.appidkey = meta.headers.get("appidkey") as string;
        }
        LoginService.authorization = meta.headers.get(
          "authorization"
        ) as string;
        LoginService.jwtToken = (meta.headers.get("ewjwt") as string).split(
          " "
        )[1];

        //  console.log(res.data);
        if (res.data.mndtryCnsts && res.data.mndtryCnsts.length) {
          this.cnsList.mandatory = true;
          this.cnsList.list.push({
            name: "textBased",
            cnsnt: res.data.mndtryCnsts,
          });
        }
        if (res.data.accs.rstusr || res.data.accs.rstpwd) {
          this.cnsList.mandatory = true;
          this.cnsList.list.push({ name: "rstpwd" });
        }
        const vendorCnst = res.data.cnsntLst.filter(
          (cnst: IAccDataCnsntLst) => cnst.mdtry
        );
        //localStorage.setItem("cnsntLst", JSON.stringify(vendorCnst));
        // const vendorCnst = [
        //   {
        //     accType: "EQ",
        //     mdtry: true,
        //     // name: "accReact",
        //     name: "invAddress",
        //   },
        //   {
        //     accType: "EQ",
        //     mdtry: true,
        //     name: "eqIncmDclr",
        //   },
        // ];
        //.find((cnst: IAccDataCnsntLst) => cnst.mdtry);
        // console.log(vendorCnst);

        if (vendorCnst && vendorCnst.length > 0) {
          this.cnsList.mandatory = true;
          vendorCnst.map((consent: any) => {
            if (
              (res.data.accs.rstusr || res.data.accs.rstpwd) &&
              consent.name === "rstpwd"
            ) {
              return;
            }
            this.cnsList.list.push({ name: consent.name });
          });
        }
        // if (res.data.cnsntLst) {
        //   this.cnsList.list.push(res.data.cnsntLst);
        //   this.cnsList.mandatory = true;
        // }
        if (this.cnsList.mandatory) {
          this.showMandatoryConsents();
        } else {
          //  First store data in local storage, then show optional consents
          saveDataInLocalStorage();
          this.showOptionalConsents();
        }
      } else {
        this.setState({
          errorMsg: (res.data && res.data.sts) || res.error.errMsg,
        });
        setTimeout(() => {
          this.changeScreenState(ELoginScreenState.LOGIN_ID);
        }, 3000);
      }

      var data = {
        LoginType: "Traditional",
        EventName: "Login Successful",
        Platform: DeviceContext().isMobile
          ? "Website_Mobile"
          : "Website_Desktop",
        InitiationScreen: "Login",
        InitiationElement: "Continue",
      };

      this.clevertapService.pushEvent(data);
    }
  };

  /* ORDER:
    1. mandatory consents (all together) (come back for 2nd point after this)
    2. Reset Userid password
    3. Vendor consent
    4. Optional Text Based (all together)
    5. Optional Action based (only first one)
    6. Clevertap (always show at the end)
    */
  showMandatoryConsents = () => {
    const consent = this.cnsList.list.shift(); // will return undefined if no consents are left
    //console.log(consent);

    if (consent?.name === "textBased") {
      AGetConsents(
        this.getConsentsRes,
        getPreLoginData("userID"),
        consent.cnsnt.map((list: IAccDataCnsntLst) => list.name)
      );
    } else if (consent?.name === "rstpwd") {
      saveDataInLocalStorage();
      this.changeScreenState(ELoginScreenState.RESET_CREDS);
    } else if (consent?.name === "vnd") {
      this.changeScreenState(ELoginScreenState.VENDOR_CNST);
    } else if (consent?.name === "eqIncmDclr") {
      saveDataInLocalStorage();
      this.goToIncomeDeclarationConsent();
    } else if (consent?.name === "invPan") {
      saveDataInLocalStorage();
      this.changePopupState(ELoginPopupState.INVALID_PAN_CNST);
    } else if (consent?.name === "emailMob") {
      saveDataInLocalStorage();
      this.goToEmailMobConsent();
    }
    else if (consent?.name === "nominee") {
      saveDataInLocalStorage();
      this.goToNominationConsent();
    }
    else if (consent?.name === "invName") {
      saveDataInLocalStorage();
      this.changePopupState(ELoginPopupState.INVALID_NAME_CNST);
    } else if (consent?.name === "accReact") {
      saveDataInLocalStorage();
      this.goToAccReactConsent();
    } else if (consent?.name === "invAddress") {
      saveDataInLocalStorage();
      this.goToAccReactConsent("Address");
    } else {
      // If mandatory consents are not left, then save data in local storage and then show CLEVERTAP
      saveDataInLocalStorage();
      this.showClevertapConsent();
    }

    // If popup was open then close that
    // if (!this.state.popupState) {
    //   this.setState({ popupMessage: undefined, popupState: undefined });
    // }
  };

  showOptionalConsents = () => {
    if (!this.skipCnsts) {
      if (getAccData("optCnsts")) {
        AGetConsents(
          this.getConsentsRes,
          getPreLoginData("userID"),
          getAccData("optCnsts").map((list: IAccDataCnsntLst) => list.name)
        );
      } else if (getAccData("cnsntLst").length) {
        switch (getAccData("cnsntLst")[0].name) {
          case "mrgPopUp":
            const othAccDts = getAccData("othAccDts");
            if (othAccDts.isAct && othAccDts.isOnline) {
              // show merge popup
              this.changeScreenState(ELoginScreenState.MERGE);
            } else {
              // show inactive account popup
              this.changePopupState(ELoginPopupState.INACTIVE_ACC);
            }
            break;

          case "eqRmRt":
            this.changeScreenState(ELoginScreenState.RM_RATING);
        }
      } else {
        this.showClevertapConsent();
      }
    } else {
      this.onClose();
    }
  };

  showClevertapConsent = () => {
    if (!this.skipCnsts) {
      this.changeScreenState(ELoginScreenState.CLEVERTAP);
    } else {
      this.onClose();
    }
  };

  getConsentsRes = (res: any) => {
    if (res.data && res.data.consents) {
      this.changeScreenState(ELoginScreenState.CONSENTS, {
        consents: res.data.consents,
      });
    } else {
      // TODO
    }
  };

  // called on accept text based consent
  saveConsents = (consents: Array<any>) => {
    this.setState({ disableForm: true });
    ASaveMulConsents(this.saveConsentsRes, getPreLoginData("userID"), consents);
  };

  // response of accept text based consents
  saveConsentsRes = (res: any) => {
    if (res.data && res.data.sts) {
      if (this.cnsList.mandatory) {
        this.showMandatoryConsents();
      } else {
        this.showClevertapConsent();
      }
    } else {
      this.setState({ disableForm: false });
    }
  };

  resetIdPw = (
    { loginId, ...values }: IChPwFields,
    resetLoginId?: boolean | undefined
  ) => {
    // no need to disable here because this screen is disabled via resetSubmitState
    this.setState({
      resetSubmitState: resetLoginId
        ? EResetSubmitState.ver_login_id
        : EResetSubmitState.ver_password,
      loginIdState: undefined,
    });

    if (resetLoginId) {
      AResetLoginId(
        (res: any, meta: Response) => this.resetLoginIdRes(res, meta, values),
        getPreLoginData("userID"),
        loginId
      );
    } else {
      AResetPassword(this.resetPasswordRes, getPreLoginData("userID"), values);
    }
  };

  resetLoginIdRes(res: any, meta: Response, values: IChangePassword) {
    if (res.data && res.data.msg) {
      this.setState({
        loginIdState: "success",
        resetSubmitState: EResetSubmitState.ver_password,
      });

      if (meta.headers.get("appidkey")) {
        urlConfig.appidkey = meta.headers.get("appidkey") as string;
      }
      LoginService.authorization = meta.headers.get("authorization") as string;
      LoginService.jwtToken = (meta.headers.get("ewjwt") as string).split(
        " "
      )[1];

      AResetPassword(this.resetPasswordRes, getPreLoginData("userID"), values);
    } else {
      this.setState({
        loginIdState: res.error.errMsg,
        resetSubmitState: undefined,
      });
    }
  }

  resetPasswordRes = (res: any) => {
    if (res.data && res.data.msg) {
      this.changePopupState(ELoginPopupState.RESET_SUCC, {
        popupMessage: res.data.msg,
      });
    } else {
      this.setState({
        errorMsg: res.error.errMsg,
        resetSubmitState: undefined,
      });
    }
  };

  requestMerge = (body: IMergeRequest) => {
    AMergeRequest((res: any) => this.requestMergeRes(res, body.mrgUid), body);
    this.setState({ disableForm: true });
  };

  requestMergeRes = (res: any, mrgUid: string) => {
    //console.log(res);
    if (res.data && res.data.sts === "REQUESTED") {
      // update mrgSts
      const userData = getAccData();
      userData.mrgSts = res.data.sts;
      setAccData(userData);
      localStorage.setItem("acc_data", userData);

      this.changePopupState(ELoginPopupState.MERGE_REQUESTED, {
        popupMessage: mrgUid,
      });
    } else {
      // set mrgSts = "NOT_REQUESTED"
      const userData = getAccData();
      userData.mrgSts = "NOT_REQUESTED";
      setAccData(userData);
      // TODO: Show error screen
    }
  };

  remindLaterMerge = () => {
    AMergeRemindLater(this.remindLaterMergeRes);
  };

  remindLaterMergeRes = (res: any) => {
    //  console.log(res);
  };

  inactiveAccOnMailSend = () => {
    if (!getAccData("othAccDts").isAct) {
      AMergeActivateAccount(
        this.inactiveAccOnMailSendRes,
        getPreLoginData("userID"),
        getPreLoginData("accTyp")
      );
    } else {
      AMergeEnableAccount(
        this.inactiveAccOnMailSendRes,
        getPreLoginData("userID"),
        getPreLoginData("accTyp")
      );
    }
  };

  inactiveAccOnMailSendRes = (res: any) => {
    // console.log(res);
    if (res.data) {
      this.changePopupState(ELoginPopupState.EMAIL_SENT);
    }
  };

  rmRatingSubmit = (body: any) => {
    ARmRateSubmit(this.rmRatingSubmitRes, getPreLoginData("userID"), body);
  };

  rmRatingSubmitRes = (res: any) => {
    if (res.data && res.data.msg === "success") {
      this.changePopupState(ELoginPopupState.RM_RATING_SUCC);
    }
  };

  submitLeadForm = (values: ILeadFormFields) => {
    this.setState({ disableForm: true });
    ACommAccOpenPre(this.submitLeadFormRes, values);
  };

  submitLeadFormRes = (res: any) => {
    if (res.data) {
      this.changePopupState(ELoginPopupState.OPEN_ACC_SUCC, {
        popupMessage: res.data.msg,
      });
    } else {
      this.setState({ errorMsg: res.error.errMsg, disableForm: false });
    }
  };

  logoutAndThenLogin = () => {
    logout();
    this.changeScreenState(ELoginScreenState.LOGIN_ID, {
      popupState: undefined,
    });
  };

  openAccount = () => {
    if (getAccData("accTyp") === "EQ") {
      // if account is equity then open lead form
      ACommAccOpenPost(this.commAccOpenPostRes, getAccData("userID"));
    } else {
      // if account is commodity then open equity account opening pitch page
      this.redirect(loginURLConfig.openAccount);
    }
  };

  commAccOpenPostRes = (res: any) => {
    // console.log(res);
  };

  checkInvtypeobj = true;
  onClose = () => {
    if (isLoggedIn()) {
      //console.log("in logged");

      // If account type is not COMEQ and invtypeobj exists, then check the acctyp of object
      // if acctype of object matches the logged in acctyp
      // then continue
      // otherwise open the merge popup depending on status
      if (
        getAccData("accTyp") !== "COMEQ" &&
        LoginService.invtypeobj &&
        this.checkInvtypeobj
      ) {
        // make it false so that we don't come to this condition again
        // console.log("1st if");

        this.checkInvtypeobj = false;

        const invtypeobj = LoginService.invtypeobj.length
          ? (LoginService.invtypeobj as Array<indexer>)[0]
          : LoginService.invtypeobj;
        if (invtypeobj.snse || invtypeobj.sbse) {
          if (invtypeobj.sbse && invtypeobj.sbse !== "") {
            invtypeobj.accTyp = "EQ";
          } else {
            if (
              invtypeobj.snse.indexOf("MCX") > -1 ||
              invtypeobj.snse.indexOf("NCDEX")
            ) {
              invtypeobj.accTyp = "CO";
            } else {
              invtypeobj.accTyp = "EQ";
            }
          }

          if (invtypeobj.accTyp !== getAccData("accTyp")) {
            LoginService.popupName = getAccData("mrgSts");
            this.openLogin();
            return;
          }
        }
      }
      if (LoginService.reUrl) {
        // console.log("2nd if");
        if (
          LoginService.reUrl.indexOf("smallcase") > -1 ||
          LoginService.reUrl.indexOf(urlConfig.root + urls.login) > -1
        ) {
          this.redirectToVendor();
        } else {
          this.redirect(
            LoginService.reUrl +
              (LoginService.params ? "&" + LoginService.params : "")
          );
        }
      } else if (
        this.cnsList &&
        this.cnsList.list &&
        this.cnsList.list.length > 0
      ) {
        this.showMandatoryConsents();
      } else {
        this.redirect(urlConfig.root + urls.home);
      }
    } else {
      this.redirect(
        LoginService.fromUrl ? LoginService.fromUrl : urlConfig.root + urls.home
      );
    }
  };

  redirect(url: string) {
    if (url.indexOf("http://") === 0 || url.indexOf("https://") === 0) {
      // If url is absolute
      window.location.href = url;
    } else {
      // if url is relative
      // this.props.history.push(url);
      // window.location.reload();
      this.history.push(url);
    }
  }
  goToIncomeDeclarationConsent = async () => {
    let response = await ServiceClientValidation({
      subType: "Income Declaration",
    });
    if (response) {
      if (response == "BOAcoountNumber not found") {
        //request not exists
        this.changePopupState(ELoginPopupState.INCOME_DECL_CNST);
      } else {
        this.redirect(urls.home);
        //request already exists-show error
      }
    }
  };
  goToAccReactConsent = async (type?: string) => {
    if (type) {
      if (type === "Address")
        this.changePopupState(ELoginPopupState.INVALID_ADDRESS_CNST);
    } else this.changePopupState(ELoginPopupState.Account_React_CNST);
  };
  goToEmailMobConsent = async () => {
    let response = await ServiceClientValidation({
      subType: "Email and Phone Update",
    });
    if (response) {
      if (response == "BOAcoountNumber not found") {
        //request not exists
        if (getAccData("accs").emailCnsnt && !getAccData("accs").mobCnsnt)
          this.changePopupState(ELoginPopupState.INVALID_EMAIL_CNST);
        else if (!getAccData("accs").emailCnsnt && getAccData("accs").mobCnsnt)
          this.changePopupState(ELoginPopupState.INVALID_MOBILE_CNST);
        else this.changePopupState(ELoginPopupState.INVALID_EMAIL_MOBILE_CNST);
      } else {
        this.redirect(urls.home);
        //request already exists-show error
      }
    }
  };
  goToNominationConsent = async () => {
    this.changePopupState(ELoginPopupState.INVALID_NOMIN_CNST);
  };
  closePopup = () => {
    this.changePopupState(undefined, {
      popupMessage: undefined,
      screenState: ELoginScreenState.LOGIN_ID,
    });
  };

  clevertapRegister = () => {
    const cleverTapId = this.clevertapService.getCleverTapID();
    //Need to make Middleware API call
    const data = {
      bwsNm: "Chrome",
      devNm: "Chrome 84.0.4147.89",
      clvTpId: cleverTapId || "",
      appid: 1718301357,
      plt: DeviceContext().isMobile ? "MB:IN" : "EWIN",
    };
    ARegisterDevice(this.registerDeviceRes, data);
  };

  clevertapNoThanks = () => {
    const cleverTapId = this.clevertapService.getCleverTapID();
    this.clevertapService.setClevertapItem({
      cleverTapDetails: `${getAccData(
        "prfId"
      )},${cleverTapId};expires=Tue, 19 Jan 2025 12:00:00 GMT`,
    });
    this.onClose();
  };

  clevertapDontShow = () => {
    this.clevertapService.setClevertapItem({
      dontShowAgain: `${getAccData("prfId")};Tue, 19 Jan 2025 12:00:00 GMT`,
    });
    this.onClose();
  };

  registerDeviceRes = (res: any) => {
    this.clevertapService.saveClevertapData();
    this.onClose();
  };

  handleTncConsent = (save: boolean) => {
    this.skipCnsts = true;
    ASaveTncConsent(
      (res: any) => this.saveTncConsentRes(res, save),
      getAccData("userID"),
      save
    );
  };

  saveTncConsentRes = (res: any, save: boolean) => {
    // if save is true, then accept was clicked, otherwise decline was clicked
    if (res.data && res.data.sts) {
      if (save) {
        this.showMandatoryConsents(); // This will save all the data in local storage
      } else {
        this.onClose();
      }
    } else {
      // TODO: How to show error here?
    }
  };

  getScreen() {
    switch (this.state.screenState) {
      case ELoginScreenState.LOADING:
        return <LoginLoaderScreen />;

      case ELoginScreenState.LOGIN_ID:
        return (
          <LoginIdScreen
            disableForm={this.state.disableForm}
            onSubmit={this.getSecurityImage}
            userName={getPreLoginData("userID")}
            errorMsg={this.state.errorMsg}
            onRemoveError={this.removeError}
            onClose={LoginService.hideCross ? undefined : this.onClose}
          />
        );

      case ELoginScreenState.PASSWORD:
        return (
          <PasswordScreen
            loginId={getPreLoginData("userID")}
            securityImgObj={this.state.imgObj}
            disableForm={this.state.disableForm}
            errorMsg={this.state.errorMsg}
            onEditLoginId={this.showUserIdScreen}
            onSubmit={this.faQuestions}
            onRemoveError={this.removeError}
            onClose={LoginService.hideCross ? undefined : this.onClose}
          />
        );

      case ELoginScreenState.YOB:
        return (
          <YobScreen
            disableForm={this.state.disableForm}
            errorMsg={this.state.errorMsg}
            onSubmit={this.verifyAnswers}
            onClose={LoginService.hideCross ? undefined : this.onClose}
          />
        );

      case ELoginScreenState.CONSENTS:
        return (
          <ConsentScreen
            consents={this.state.consents!}
            mandatory={this.cnsList.mandatory || false}
            onSubmit={this.saveConsents}
            disable={this.state.disableForm}
            onClose={LoginService.hideCross ? undefined : this.onClose}
          />
        );

      case ELoginScreenState.RESET_CREDS:
        return (
          <ResetCredsScreen
            onSubmit={this.resetIdPw}
            submitState={this.state.resetSubmitState}
            errorMsg={this.state.errorMsg}
            onClose={LoginService.hideCross ? undefined : this.onClose}
            loginIdState={this.state.loginIdState}
            onRemoveError={this.removeError}
          />
        );

      case ELoginScreenState.VENDOR_CNST:
        return (
          <TncConsentScreen
            disableButton={this.state.disableForm}
            onButtonClick={this.handleTncConsent}
            onClose={this.onClose}
          />
        );

      case ELoginScreenState.CLEVERTAP:
        return (
          <LoginClevertapScreen
            onDontShow={this.clevertapDontShow}
            onNoThanks={this.clevertapNoThanks}
            onRegister={this.clevertapRegister}
            onClose={LoginService.hideCross ? undefined : this.onClose}
          />
        );

      case ELoginScreenState.MERGE:
        return (
          <MergeIdScreen
            disableForm={this.state.disableForm}
            requestMerge={this.requestMerge}
            remindLater={this.remindLaterMerge}
            onClose={LoginService.hideCross ? undefined : this.onClose}
          />
        );

      case ELoginScreenState.RM_RATING:
        return (
          <RmRatingScreen
            onSubmit={this.rmRatingSubmit}
            onClose={LoginService.hideCross ? undefined : this.onClose}
          />
        );

      case ELoginScreenState.ACC_OPENING:
        return (
          <OpenAccountScreen
            onClose={
              LoginService.hideCross
                ? undefined
                : () => this.changeScreenState(ELoginScreenState.LOGIN_ID)
            }
          />
        );

      case ELoginScreenState.LEAD_FORM:
        return (
          <LeadFormScreen
            errorMsg={this.state.errorMsg}
            onRemoveError={this.removeError}
            onSubmit={this.submitLeadForm}
            disableForm={this.state.disableForm}
            onClose={
              LoginService.hideCross
                ? undefined
                : () => this.changeScreenState(ELoginScreenState.LOGIN_ID)
            }
          />
        );

      default:
        return <></>;
    }
  }

  getPopup() {
    switch (this.state.popupState) {
      case ELoginPopupState.RESET_SUCC:
        return (
          <LoginStatusScreen
            popupState={this.state.popupState}
            message={this.state.popupMessage}
            onLinkClick={this.showMandatoryConsents}
            onClose={LoginService.hideCross ? undefined : this.onClose}
          />
        );

      case ELoginPopupState.LOGINID_SENT:
      case ELoginPopupState.MERGE_REQUESTED:
        return (
          <LoginStatusScreen
            popupState={this.state.popupState}
            message={this.state.popupMessage}
            onLinkClick={
              LoginService.hideCross
                ? undefined
                : () =>
                    this.changePopupState(undefined, {
                      popupMessage: undefined,
                      screenState: ELoginScreenState.CLEVERTAP,
                    })
            }
            onClose={this.closePopup}
          />
        );

      case ELoginPopupState.INACTIVE_ACC:
        return (
          <LoginStatusScreen
            popupState={this.state.popupState}
            onButtonClick={this.inactiveAccOnMailSend}
            onLinkClick={this.onClose}
            onClose={LoginService.hideCross ? undefined : this.closePopup}
          />
        );

      case ELoginPopupState.RM_RATING_SUCC:
        return (
          <RmRatingSuccPopup
            onClose={() =>
              this.changeScreenState(ELoginScreenState.CLEVERTAP, {
                popupState: undefined,
              })
            }
          />
        );

      case ELoginPopupState.OPEN_ACC_SUCC:
        return (
          <LoginStatusScreen
            popupState={this.state.popupState}
            onLinkClick={this.onClose}
            message={this.state.popupMessage}
            onClose={this.closePopup}
          />
        );

      case ELoginPopupState.REQUESTED:
      case ELoginPopupState.NOT_ENABLED:
        return (
          <LoginStatusScreen
            popupState={this.state.popupState}
            onClose={this.closePopup}
            onButtonClick={this.logoutAndThenLogin}
          />
        );

      case ELoginPopupState.ONE_ACCOUNT:
        return (
          <LoginStatusScreen
            popupState={this.state.popupState}
            onButtonClick={this.openAccount}
            onLinkClick={this.onClose}
            onClose={this.closePopup}
          />
        );

      case ELoginPopupState.EMAIL_SENT:
        return (
          <LoginStatusScreen
            popupState={this.state.popupState}
            onClose={this.closePopup}
          />
        );

      case ELoginPopupState.LOGIN_FAILED:
        return (
          <LoginStatusScreen
            popupState={this.state.popupState}
            message={this.state.popupMessage}
            onClose={this.closePopup}
            onLinkClick={() =>
              this.changeScreenState(ELoginScreenState.LOGIN_ID, {
                popupMessage: undefined,
                popupState: undefined,
              })
            }
          />
        );
      case ELoginPopupState.INCOME_DECL_CNST:
        return <IncomeDeclarationConsent />;
      case ELoginPopupState.INVALID_EMAIL_CNST:
        return (
          <ConsentPopupScreen type="email" onClose={() => this.onClose()} />
        );
      case ELoginPopupState.INVALID_NOMIN_CNST:
        return <ConsentPopupScreen type="nominee" />;
      case ELoginPopupState.INVALID_MOBILE_CNST:
        return (
          <ConsentPopupScreen type="mobile" onClose={() => this.onClose()} />
        );
      case ELoginPopupState.INVALID_EMAIL_MOBILE_CNST:
        return (
          <ConsentPopupScreen type="emailMob" onClose={() => this.onClose()} />
        );
      case ELoginPopupState.INVALID_PAN_CNST:
        return <ConsentPopupScreen type="pan" onClose={() => this.onClose()} />;
      case ELoginPopupState.INVALID_NAME_CNST:
        return (
          <ConsentPopupScreen type="name" onClose={() => this.onClose()} />
        );
      case ELoginPopupState.Account_React_CNST:
        return <AccountReactivationConsent />;
      case ELoginPopupState.INVALID_ADDRESS_CNST:
        return <AccountReactivationConsent type="Change of Address" />;
      default:
        return undefined;
    }
  }

  render() {
    return (
      <>
        {this.getScreen()} {this.getPopup()}
      </>
    );
  }
}

export default LoginCtrl;
